// Entry da home do redesign. Precisa ficar direto em javascripts/pages porque
// o build não reconhece entry points em subpastas.

import setRanking from '../redesign/home/ranking';
import setStories from '../redesign/home/stories';
import setLocals from './home/locals';

window.addEventListener('DOMContentLoaded', () => {
  setRanking();
  setStories();
  setLocals();
});
